export default __webpack_public_path__ + "static/media/loginsvg.d590a8e4.svg";